// removed by extract-text-webpack-plugin
module.exports = {"email-ingest-token-modal":"email-ingest-token-modal","modal-body":"modal-body","email-ingest-intro":"email-ingest-intro","email-ingest-label":"email-ingest-label","email-ingest-content":"email-ingest-content","email-ingest-enable":"email-ingest-enable","email-ingest-token":"email-ingest-token","email-ingest-address":"email-ingest-address"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/email-ingest-token-modal/email-ingest-token-modal.style.sass
// module id = 1CE5
// module chunks = 0